import getRootDomain from '../../utils/getRootDomain';
import Storage from './Storage';

const DURATION_ONE_DAY = 1 * 24 * 60 * 60 * 1000;

class CookieStorage extends Storage {
  static rootDomain = getRootDomain(window.location.href);

  static separator = '|';

  static get(key: string): string | null {
    const name = `${key}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieCrumbles = decodedCookie.split(';');
    const cookieCrumble = cookieCrumbles.find((crumble) => crumble.trim().startsWith(name));
    const value = cookieCrumble
      ? cookieCrumble.trim().substring(name.length, cookieCrumble.length)
      : null;
    return value;
  }

  static set(
    key: string,
    value: string,
    expires?: Date,
  ): void {
    const exp = this.computeCookieExpiresAttr(expires);
    document.cookie = `${key}=${value};${exp};domain=${this.rootDomain};path=/`;
  }

  private static computeCookieExpiresAttr(expires?: Date): string {
    if (expires instanceof Date) {
      return `expires=${expires.toUTCString()}`;
    }
    // Set the cookie to expire in 1 day
    const d = new Date();
    d.setTime(d.getTime() + DURATION_ONE_DAY);
    return `expires=${d.toUTCString()}`;
  }

  static remove(key: string): void {
    document.cookie = `${key}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
  }
}

export default CookieStorage;
